import { AUTHENTICATION, SEAL_NETWORK, SEAL_SYSTEMS } from '@Constants/types';

const initialState = {
    isSignedIn: false,
    isAuthenticating: false,
    isAuthenticated: false,
    lastPrincipal: '',
    // to be removed
    // activeUser: {
    //     isAuthenticating: false,
    //     isAuthenticated: false
    // },
    //
    serverResponse: null,
    activeSystem: '',
    sealSystems: {},
    user: [],
    betaFeatures: [],
    version: '',
    releaseVersion: '',
    mockedSealVersion: '',
    isVersionMocked: false,
    showReleaseNotes: false
};

let systems = {};

export default function authenticationReducer(state = initialState, action) {
    switch (action.type) {
        case SEAL_SYSTEMS.SEAL_SYSTEM_UPDATE:
            systems[action.payload.sealUrl] = {
                name: action.payload.sealName,
                version: action.payload.sealVersion,
                auth: {
                    token: action.payload.authToken,
                    type: action.payload.authType,
                    expirytime: action.payload.expiryTokenTime,
                    authSection: action.payload.authSection
                }
            };
            return {
                ...state,
                sealSystems: systems,
                activeSystem: action.payload.sealUrl
            };

        // case SEAL_SYSTEMS.SEAL_SYSTEMS_REMOVE_ALL:
        //     return {
        //         ...state,
        //         sealSystems: initialState.sealSystems,
        //         activeSystem: ''
        //     };
        case SEAL_SYSTEMS.SEAL_SYSTEMS_UPDATE_ALL:
            action.payload.map(system => {
                systems[system.sealUrl] = {
                    name: system.friendlyName,
                    version: 'v3',
                    auth: {
                        token: system.authToken,
                        type: system.authType,
                        expirytime: system.tokenIssueTime,
                        authSection: system.authSection
                    }
                };
                return null;
            });

            return {
                ...state,
                sealSystems: systems
            };

        case SEAL_SYSTEMS.SEAL_SYSTEM_REMOVE:
            systems = state.sealSystems;
            delete systems[action.payload];
            return {
                ...state,
                sealSystems: systems,
                activeSystem: ''
            };

        case SEAL_NETWORK.SERVER_DOWN_ERROR:
            return {
                ...state,
                isAuthenticated: false,
                isSignedIn: false,
                serverResponse: {
                    message:
                        "The system can't be reached, check if it's properly configured and running then try again.",
                    type: 1
                }
            }; // error
        case SEAL_NETWORK.ERROR_MESSAGE:
            return {
                ...state,
                isAuthenticating: false,
                serverResponse: { message: action.payload, type: 1 }
            }; // error
        case SEAL_NETWORK.UNAUTHORIZED:
            return {
                ...state,
                isAuthenticated: false,
                isSignedIn: false,
                serverResponse: {
                    message:
                        "The system can't be reached, try logging in again or check your credentials.",
                    type: 1
                }
            }; // error

        case AUTHENTICATION.LOGIN_REQUEST:
            return {
                ...state,
                isAuthenticating: true,
                isAuthenticated: false,
                isSignedIn: false,
                lastPrincipal: action.payload
            };
        case AUTHENTICATION.SIGNED_IN:
            return {
                ...state,
                isSignedIn: true,
                user: action.payload
            };
        case AUTHENTICATION.LOGIN_SUCCESS:
            return {
                ...state,
                isAuthenticating: false,
                isAuthenticated: true,
                user: action.payload,
                lastPrincipal: ''
            };
        case AUTHENTICATION.UPDATE_USERS_USERVIEWS:
            return { ...state, user: { ...state.user, accessibleLabels: action.payload } };
        case AUTHENTICATION.LOGIN_FAILURE:
            return {
                ...state,
                isAuthenticated: false,
                isSignedIn: false,
                isAuthenticating: false,
                serverResponse: { message: action.payload, type: 1 }
            }; // error
        case AUTHENTICATION.LOGOUT_SUCCESS:
            return {
                ...state,
                isAuthenticating: false,
                isAuthenticated: false,
                isSignedIn: false,
                serverResponse: null,
                releaseVersion: '',
                mockedSealVersion: '',
                isVersionMocked: false,
                version: '',
                user: []
            };
        case AUTHENTICATION.CLEAR_ERROR:
            return {
                ...state,
                serverResponse: null
            };
        case AUTHENTICATION.SSO_REQUEST:
            return { ...state, isAuthenticated: false };
        case AUTHENTICATION.SSO_FAILURE:
            return {
                ...state,
                isAuthenticated: false,
                isSignedIn: false,
                serverResponse: { message: action.message, type: 1 }
            }; // error
        case AUTHENTICATION.SET_SEAL_VERSION:
            return {
                ...state,
                releaseVersion: action.payload,
                version: action.payload
            };
        case AUTHENTICATION.GET_VERSION_FAILURE:
            return {
                ...state,
                serverResponse: { message: action.payload, type: 1 }
            };
        case AUTHENTICATION.MOCK_VERSION_NOT_SET:
            return {
                ...state,
                serverResponse: {
                    message: 'Version number for testing is not set, please add one and try again.',
                    type: 1
                }
            };
        case AUTHENTICATION.UN_MOCK_SEAL_VERSION:
            return {
                ...state,
                isVersionMocked: false,
                mockedSealVersion: '',
                version: ''
            };
        case AUTHENTICATION.SET_MOCK_VERSION:
            return {
                ...state,
                isVersionMocked: true,
                mockedSealVersion: action.payload,
                version: action.payload
            };
        case AUTHENTICATION.SET_BETA_FEATURE:
            return {
                ...state,
                betaFeatures: state.betaFeatures.includes(action.payload)
                    ? state.betaFeatures
                    : [...state.betaFeatures, action.payload]
            };
        case AUTHENTICATION.REMOVE_BETA_FEATURE:
            return {
                ...state,
                betaFeatures: state.betaFeatures.filter(
                    betaFeature => betaFeature !== action.payload
                )
            };
        case AUTHENTICATION.CLEAR_BETA_FEATURES:
            return {
                ...state,
                betaFeatures: []
            };
        case AUTHENTICATION.TOGGLE_RELEASE_DIALOG:
            return {
                ...state,
                showReleaseNotes: !state.showReleaseNotes
            };
        default:
            return state;
    }
}
